var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('headernavbar-view'),_vm._v(" "),_c('div',{staticClass:"inner_contents"},[_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }